import { Schema } from 'mongoose';

const coupon = new Schema({
  active: {
    type: Boolean,
    required: true,
  },
  owner: {
    type: Schema.Types.ObjectId,
    ref: 'User',
    required: true,
  },
  code: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
  value: {
    type: Number,
    required: true,
    min: 1,
  },
  expiration: {
    type: Date,
    required: true,
  },
});

export default coupon;
